module.exports = __webpack_public_path__ + "img/mw.2dc0be61.svg";